<template>
    <div class="order">
      <h1>在线点单</h1>
      <p>请先浏览菜单，然后在这里选择您要点的菜品。</p>
      {/* 假设您已经从后端获取到了菜单数据，并存储在 menuItems 数组中 */}
      <div v-if="menuItems.length > 0">
        <div v-for="item in menuItems" :key="item.id" class="menu-item">
          <h3>{{ item.name }}</h3>
          <p>{{ item.description }}</p>
          <p>价格: ￥{{ item.price }}</p>
          <button @click="addToCart(item)">加入购物车</button>
        </div>
      </div>
      <div v-else>
        加载中...
      </div>
  
      <h2>购物车</h2>
      <ul>
        <li v-for="item in cart" :key="item.id">
          {{ item.name }} x {{ item.quantity }} - ￥{{ (item.price * item.quantity).toFixed(2) }}
          <button @click="removeFromCart(item)">移除</button>
        </li>
      </ul>
      <p>总价: ￥{{ total }}</p>
  
      <button @click="submitOrder" :disabled="cart.length === 0">提交订单</button>
    </div>
  </template>
  
  <script>
  import api from '@/api'; // 假设您已经封装了 API 请求
  
  export default {
    name: 'OrderPage',
    data() {
      return {
        menuItems: [],
        cart: [],
        total: 0,
        // ... 其他订单相关数据
      };
    },
    mounted() {
      this.fetchMenu();
    },
    methods: {
      async fetchMenu() {
        try {
          const response = await api.getMenu();
          this.menuItems = response.data;
        } catch (error) {
          console.error('获取菜单失败:', error);
        }
      },
      addToCart(item) {
        const existingItem = this.cart.find(cartItem => cartItem.id === item.id);
        if (existingItem) {
          existingItem.quantity++;
        } else {
          this.cart.push({ ...item, quantity: 1 });
        }
        this.calculateTotal();
      },
      removeFromCart(item) {
        const index = this.cart.findIndex(cartItem => cartItem.id === item.id);
        if (index !== -1) {
          if (this.cart[index].quantity > 1) {
            this.cart[index].quantity--;
          } else {
            this.cart.splice(index, 1);
          }
        }
        this.calculateTotal();
      },
      calculateTotal() {
        this.total = this.cart.reduce((sum, item) => sum + item.price * item.quantity, 0);
      },
      async submitOrder() {
        // ... 提交订单到后端 API
        try {
            const orderData = {
              order_items: this.cart.map(item => ({
                  id: item.id,
                  name: item.name,
                  quantity: item.quantity,
                  price: item.price
              })),
              total_price: this.total,
              // ... 其他订单信息，例如地址、联系方式等
              address: 'your_address', // 需要替换为真实地址
              phone: 'your_phone', // 需要替换为真实电话号码
            };
  
            const response = await api.createOrder(orderData);
  
            console.log('订单创建成功:', response);
            alert('订单创建成功！订单ID：' + response.data.order_id);
  
            // 清空购物车
            this.cart = [];
            this.total = 0;
  
            // 可以选择跳转到订单详情页或提示用户订单已提交
          } catch (error) {
            console.error('订单创建失败:', error);
            alert('订单创建失败，请稍后重试！');
          }
      },
    },
  };
  </script>
  
  <style scoped>
  .order {
    padding: 20px;
  }
  .menu-item {
    border: 1px solid #ccc;
    margin-bottom: 10px;
    padding: 10px;
  }
  /* 移动端适配 */
  @media (max-width: 768px) {
    .order {
      padding: 10px;
    }
  }
  </style>